// extracted by mini-css-extract-plugin
export default {"BestRatedBooks":"BestRatedBooks_BestRatedBooks__BgK5+","List":"BestRatedBooks_List__RzMog"};